exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lr-box[data-v-4ac97a61]{padding:20px;min-width:300px;max-width:500px}.lr-alert-msg[data-v-4ac97a61]{margin-bottom:20px;color:#45505b}", "", {"version":3,"sources":["C:/Work/widget/src/components/Global/C:\\Work\\widget/src\\components\\Global\\Alert.vue"],"names":[],"mappings":"AAqCA,yBACE,aAAa,AACb,gBAAgB,AAChB,eAAgB,CACjB,AAGD,+BACE,mBAAmB,AACnB,aAAc,CACf","file":"Alert.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n.lr-box {\r\n  padding: 20px;\r\n  min-width: 300px;\r\n  max-width: 500px;\r\n}\r\n\r\n\r\n.lr-alert-msg{\r\n  margin-bottom: 20px;\r\n  color: #45505b;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ac97a61","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/Alert.vue
// module id = 1013
// module chunks = 0